// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["css/app","css/bootstrap","css/tailwind"], () => (__webpack_require__("./node_modules/bootstrap/dist/js/bootstrap.bundle.js")))
__webpack_require__.O(undefined, ["css/app","css/bootstrap","css/tailwind"], () => (__webpack_require__("./scss/_tailwind.scss")))
__webpack_require__.O(undefined, ["css/app","css/bootstrap","css/tailwind"], () => (__webpack_require__("./scss/_bootstrap.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["css/app","css/bootstrap","css/tailwind"], () => (__webpack_require__("./scss/app.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
